import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './layout';

export const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setDevMode(s, { payload: enabled }) {
            s.ttDev = enabled;
        },
        setScrolling(s, { payload: scrolling }) {
            s.scrolling = scrolling;
        },
        setQuestionScrolling(s, { payload: questionId }) {
            s.questionScrolling = questionId;
        },
        setMobileFoldersOpen(s, { payload: open }) {
            if (typeof open !== 'undefined') {
                s.mobileFoldersOpened = open;
            } else {
                s.mobileFoldersOpened = !s.mobileFoldersOpened;
            }
        },
    },
});
